import { createAxios } from "./axiosHttpMarconi";

export const incotermsService = {
  getIncoterms,
  deleteIncoterm,
  postIncoterm,
  updateIncoterm,
  getIncotermById,
};

function getIncoterms(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/incoterms`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0";
  }
  if (filters && filters.codigo) {
    urlPath += `&codigo=${filters.codigo}`;
  }
  if (filters && filters.courier) {
    urlPath += `&courier=${filters.courier}`;
  }
  if (filters && filters.destino) {
    urlPath += `&destino=${filters.destino}`;
  }
  return axios.get(urlPath);
}

function deleteIncoterm(sulucionReglaId) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/incoterms/${sulucionReglaId}`;
  return axios.delete(urlPath);
}

function postIncoterm(request) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/incoterms`;
  return axios.post(urlPath, request);
}

function updateIncoterm(id, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/incoterms/${id}`;
  return axios.put(urlPath, body);
}

function getIncotermById(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/incoterms/${id}`;
  return axios.get(urlPath);
}
